module.exports = __webpack_public_path__ + "img/form-t1.3b0c4d48.svg";